import React from "react";
import { Modal } from "react-bootstrap";
import "./index.css";
const UpdateUserStatusModal = ({ hide, show, title, eventHandler }) => {
  return (
    <Modal show={show} onHide={hide} centered>
      <Modal.Body>
        <h5 className="text-center">{title}</h5>
        <div className="text-end">
          <button className="btn text-danger" onClick={hide}>
            Cancel
          </button>
          <button className="ms-3 btn" onClick={() => eventHandler()}>
            Yes
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateUserStatusModal;
